import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';

import Button from '~/components/common/Button';
import {verifyDotMc} from '~/modules/dots/actions';
import DotMessage from '../common/DotMessage';
import mapDispatch from '~/misc/mapDispatch';
import LabeledInput from '../common/LabeledInput';

import css from './index.css';

class DotValidate extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeDotOrMC = this.changeDotOrMC.bind(this);
    this.state = {
      showDotInput: true,
      formData: {
        dot: '',
        mc: '',
      },
    };
  }

  render() {
    const formData = this.state.formData;
    return (
      <div className={css.popwrap}>
        <h1 className={css.header}> Verify DOT/MC number </h1>
        <form className={css.formWrap}>
          <DotMessage/>
          <div className={css.dotWrap}>
            <span onClick={this.changeDotOrMC} className={this.state.showDotInput && cs(css.dotActive)}>DOT</span>
            <span onClick={this.changeDotOrMC} className={!this.state.showDotInput && cs(css.dotActive)}>MC</span>
          </div>
          <div className={css.strenchInput}>
            {this.state.showDotInput
              ? <LabeledInput
                wrapClassName={css.block}
                autoFocus={true}
                type='dot'
                name='dot'
                value={formData.dot}
                onChange={this.handleChange}
                onBlur={this.handleChange}
              />
              : <LabeledInput
                wrapClassName={css.block}
                autoFocus={true}
                type='mc'
                name='mc'
                value={formData.mc}
                onChange={this.handleChange}
                onBlur={this.handleChange}
              />
            }
          </div>
        </form>
        <div className={css.btnWrap}>
          {this.props.errorMsg
            && (<div className={css.error}>{this.props.errorMsg}</div>)
          }
          <Button onClick={this.submit} className={css.wide} mods={['action']}>Submit</Button>
        </div>

      </div>
    );
  }

  handleChange(e) {
    this.setState({
      formData: Object.assign({}, this.state.formData, {[e.target.name]: e.target.value}),
    });
  }

  changeDotOrMC(e) {
    const innerText = e.target.innerText;
    const showDot = (innerText === 'DOT');
    this.setState({
      showDotInput: showDot,
      formData: {
        dot: showDot ? this.state.formData.dot : '',
        mc: showDot ? '' : this.state.formData.mc,
      },
    });
  }

  submit() {
    this.props.verifyDotMc(this.state.formData);
  }
}

export default connect((state) => ({errorMsg: state.dots.verifyDotMcData.error || false}), mapDispatch({
  verifyDotMc: (data, formData) => verifyDotMc(formData),
}))(DotValidate);




// WEBPACK FOOTER //
// ./src/components/DotValidate/index.js